import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ReferenceCache } from '../../reference/services/reference.cache';
import { UserManager } from '../services/user/user.manager';

/**
 * This component acts as the main "dashboard" for Online Claims users.
 * 
 * NOTE: This component currently has no explicit functionality and only hosts the existing claim form.
 */
@Component({
	selector: 'claims-app-dashboard',
	templateUrl: './claims-app-dashboard.component.html'
})
export class ClaimsAppDashboardComponent implements OnInit, OnDestroy {
	public errorLoadingData: boolean = false;
	/**
	 * A subject that can be used to automatically end subscriptions when the component is destroyed.
	 * @private
	 */
	private readonly _destroying$ = new Subject<void>();

	constructor(private referenceCache: ReferenceCache, private userManager: UserManager) { }

	ngOnInit(): void {
		this.referenceCache.dataError$
			.pipe(takeUntil(this._destroying$))
			.subscribe(() => this.errorLoadingData = true);
		
		this.userManager.dataError$
			.pipe(takeUntil(this._destroying$))
			.subscribe(() => this.errorLoadingData = true);
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}
}